var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTemplateImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 128,
    viewBox: "0 0 320 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 128,
    rx: 12,
    fill: "#0C0C0C",
    fillOpacity: 0.15
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.005 81.5435C129.809 89.0554 135.85 95.0973 143.359 95.9342C148.936 96.5558 154.662 97.0897 160.5 97.0897C166.338 97.0897 172.064 96.5558 177.641 95.9342C185.149 95.0973 191.191 89.0554 191.995 81.5435C192.588 75.998 193.089 70.3047 193.089 64.5004C193.089 58.6961 192.588 53.0028 191.995 47.4574C191.191 39.9454 185.149 33.9036 177.641 33.0667C172.064 32.445 166.338 31.9111 160.5 31.9111C154.662 31.9111 148.936 32.445 143.359 33.0667C135.85 33.9036 129.809 39.9454 129.005 47.4574C128.412 53.0028 127.911 58.6961 127.911 64.5004C127.911 70.3047 128.412 75.998 129.005 81.5435Z",
    fill: "#FAFAFA",
    stroke: "#DBDBDB",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.005 81.5435C129.809 89.0554 135.85 95.0973 143.359 95.9342C148.936 96.5558 154.662 97.0897 160.5 97.0897C166.338 97.0897 172.064 96.5558 177.641 95.9342C185.149 95.0973 191.191 89.0554 191.995 81.5435C192.588 75.998 193.089 70.3047 193.089 64.5004C193.089 58.6961 192.588 53.0028 191.995 47.4574C191.191 39.9454 185.149 33.9036 177.641 33.0667C172.064 32.445 166.338 31.9111 160.5 31.9111C154.662 31.9111 148.936 32.445 143.359 33.0667C135.85 33.9036 129.809 39.9454 129.005 47.4574C128.412 53.0028 127.911 58.6961 127.911 64.5004C127.911 70.3047 128.412 75.998 129.005 81.5435Z",
    stroke: "#DBDBDB",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.625 61.8926C174.665 61.8926 178.75 57.8072 178.75 52.7676C178.75 47.728 174.665 43.6426 169.625 43.6426C164.585 43.6426 160.5 47.728 160.5 52.7676C160.5 57.8072 164.585 61.8926 169.625 61.8926Z",
    fill: "white",
    stroke: "#DBDBDB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.359 95.9332C135.851 95.0962 129.809 89.0544 129.005 81.5425C128.518 76.9859 128.093 72.3296 127.957 67.5938C130.08 67.2638 132.226 67.1007 134.377 67.1065C143.473 66.9008 152.347 69.9337 159.414 75.6642C165.969 80.9788 170.575 88.293 172.548 96.4602C168.595 96.8286 164.575 97.0887 160.5 97.0887C154.662 97.0887 148.936 96.5548 143.359 95.9332Z",
    fill: "white",
    stroke: "#DBDBDB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.548 96.4612C174.258 96.3017 175.957 96.1219 177.641 95.9342C185.149 95.0973 191.191 89.0554 191.995 81.5435C192.084 80.7095 192.171 79.8721 192.255 79.0316C188.693 78.0381 185.009 77.5341 181.305 77.5362C175.694 77.524 170.14 78.6597 164.984 80.8734L164.984 81.2193C168.598 85.6508 171.193 90.855 172.548 96.4612Z",
    fill: "white",
    stroke: "#DBDBDB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplateImage);
export default __webpack_public_path__ + "static/media/template-image.e9df0ddd71962d8c8343ed44ee13129a.svg";
export { ForwardRef as ReactComponent };